module.exports = __webpack_public_path__ + "img/72.6777338e.png";